<div class="side-nav-bar">
  <div class="side-nav-items" [class.expanded]="menuExpanded()">
    @for (item of itemList(); track item.code; let first = $first) {
      <locumsnest-menu-list-item
        class="menu-list-item"
        [idx]="idx() + '__nav-bar-item'"
        [item]="item"
        [filterCount]="filterCount()"
        [isFirstElement]="first"
        [activeNavItem]="activeNavItem()"
        [filtersDisabled]="filtersDisabled()"
        [nestPanelExpanded]="nestPanelExpanded()"
        [menuExpanded]="menuExpanded()"
        [hospitalOfficerPath]="hospitalOfficerPath()"
        [itemListLength]="itemList().length"
        [isAgencyPlatform]="isAgencyPlatform()"
        (clicked)="clicked.emit()"
        (toggled)="toggled.emit()"
        (filterMenuClicked)="filterMenuClicked.emit()"
      />
    }
    <div class="side-nav-bar__arrows">
      <button
        class="side-nav-bar__arrows__arrow"
        type="button"
        [class.side-nav-bar__arrows__arrow--left]="menuExpanded()"
        [class.side-nav-bar__arrows__arrow--right]="!menuExpanded()"
        [id]="idx() + (menuExpanded() ? '__nav-bar__arrow-left' : '__nav-bar__arrow-right')"
        [attr.aria-expanded]="menuExpanded()"
        [attr.aria-label]="menuExpanded() ? 'Collapse menu' : 'Expand menu'"
        (click)="onMenuExpanded()"
      ></button>
    </div>
  </div>
  <ng-content />
</div>

@if (!isAgencyPlatform()) {
  <button
    class="messaging-menu"
    type="button"
    aria-label="Messages"
    [class.messaging-menu--open]="showMessagingPanel()"
    [attr.aria-expanded]="showMessagingPanel()"
    (click)="messagingMenuClicked.emit()"
  >
    <span class="messaging-icon" [class.messaging-icon--open]="showMessagingPanel()"></span>
    @if (hasUnreadMessages()) {
      <span class="unread-messages" [class.unread-messages--open]="showMessagingPanel()"></span>
    }
  </button>
}
